/**
 *  CMS Subscription model
 */
export class LMSSubscription {
  constructor(
    public id: number,
    public code: string,
    public name: string,
    public description: string,
    public slugName: string,
    public toggleDropdown: string,
    public icon: string,
    public displayOrder: number,
    public shortcutName: string,
    public product: string,
    public courses?: Array<any>, // NOTE: This courses array is not currently being used.
    public linkType?: string,
    public menuDescription?: string,
    public canShowProductInMenu?: boolean,
    public canShowProduct?: boolean,
    public displayName?: string
  ) {}
}
